/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    GenderAndSterilizationV2Model,
    instanceOfGenderAndSterilizationV2Model,
    GenderAndSterilizationV2ModelFromJSON,
    GenderAndSterilizationV2ModelFromJSONTyped,
    GenderAndSterilizationV2ModelToJSON,
} from './GenderAndSterilizationV2Model';
import {
    PetBreedModel,
    instanceOfPetBreedModel,
    PetBreedModelFromJSON,
    PetBreedModelFromJSONTyped,
    PetBreedModelToJSON,
} from './PetBreedModel';
import {
    PetMedicalConditionModel,
    instanceOfPetMedicalConditionModel,
    PetMedicalConditionModelFromJSON,
    PetMedicalConditionModelFromJSONTyped,
    PetMedicalConditionModelToJSON,
} from './PetMedicalConditionModel';
import {
    PetMedicationAllergyModel,
    instanceOfPetMedicationAllergyModel,
    PetMedicationAllergyModelFromJSON,
    PetMedicationAllergyModelFromJSONTyped,
    PetMedicationAllergyModelToJSON,
} from './PetMedicationAllergyModel';
import {
    PetMedicationModel,
    instanceOfPetMedicationModel,
    PetMedicationModelFromJSON,
    PetMedicationModelFromJSONTyped,
    PetMedicationModelToJSON,
} from './PetMedicationModel';
import {
    PetTypeV2FormConfigModel,
    instanceOfPetTypeV2FormConfigModel,
    PetTypeV2FormConfigModelFromJSON,
    PetTypeV2FormConfigModelFromJSONTyped,
    PetTypeV2FormConfigModelToJSON,
} from './PetTypeV2FormConfigModel';
import {
    PetV2PrimaryDisciplineModel,
    instanceOfPetV2PrimaryDisciplineModel,
    PetV2PrimaryDisciplineModelFromJSON,
    PetV2PrimaryDisciplineModelFromJSONTyped,
    PetV2PrimaryDisciplineModelToJSON,
} from './PetV2PrimaryDisciplineModel';

/**
 * @type FormFieldSelectValueValueModel
 * 
 * @export
 */
export type FormFieldSelectValueValueModel = GenderAndSterilizationV2Model | PetBreedModel | PetMedicalConditionModel | PetMedicationAllergyModel | PetMedicationModel | PetTypeV2FormConfigModel | PetV2PrimaryDisciplineModel;

export function FormFieldSelectValueValueModelFromJSON(json: any): FormFieldSelectValueValueModel {
    return FormFieldSelectValueValueModelFromJSONTyped(json, false);
}

export function FormFieldSelectValueValueModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormFieldSelectValueValueModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return { ...GenderAndSterilizationV2ModelFromJSONTyped(json, true), ...PetBreedModelFromJSONTyped(json, true), ...PetMedicalConditionModelFromJSONTyped(json, true), ...PetMedicationAllergyModelFromJSONTyped(json, true), ...PetMedicationModelFromJSONTyped(json, true), ...PetTypeV2FormConfigModelFromJSONTyped(json, true), ...PetV2PrimaryDisciplineModelFromJSONTyped(json, true) };
}

export function FormFieldSelectValueValueModelToJSON(value?: FormFieldSelectValueValueModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfGenderAndSterilizationV2Model(value)) {
        return GenderAndSterilizationV2ModelToJSON(value as GenderAndSterilizationV2Model);
    }
    if (instanceOfPetBreedModel(value)) {
        return PetBreedModelToJSON(value as PetBreedModel);
    }
    if (instanceOfPetMedicalConditionModel(value)) {
        return PetMedicalConditionModelToJSON(value as PetMedicalConditionModel);
    }
    if (instanceOfPetMedicationAllergyModel(value)) {
        return PetMedicationAllergyModelToJSON(value as PetMedicationAllergyModel);
    }
    if (instanceOfPetMedicationModel(value)) {
        return PetMedicationModelToJSON(value as PetMedicationModel);
    }
    if (instanceOfPetTypeV2FormConfigModel(value)) {
        return PetTypeV2FormConfigModelToJSON(value as PetTypeV2FormConfigModel);
    }
    if (instanceOfPetV2PrimaryDisciplineModel(value)) {
        return PetV2PrimaryDisciplineModelToJSON(value as PetV2PrimaryDisciplineModel);
    }

    return {};
}

